export function removeKeyObject<T extends Record<string, any>>(
	data: T,
	callback: (key: string, value: any) => boolean,
): Partial<T> {
	const result: Partial<T> = {};

	for (const key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			const iterator = data[key];

			if (typeof iterator === 'object' && iterator !== null) {
				// Recursively process nested objects
				// @ts-ignore
				result[key] = removeKeyObject(iterator, callback);
			} else if (!callback(key, data[key])) {
				// Include the key-value pair if the callback returns false
				result[key] = data[key];
			}
		}
	}

	return result;
}
